import { render, staticRenderFns } from "./ButtonSize.vue?vue&type=template&id=dbb8ec5c"
import script from "./ButtonSize.vue?vue&type=script&lang=js"
export * from "./ButtonSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports